const NotFound = () => {
  return (
    <h5>
      PAGE NOT FOUND
    </h5>
  )
}

export default NotFound
